module.exports = __webpack_public_path__ + "img/ICTConsultancy.75fdaec7.jpeg";